import { defineMessages } from 'react-intl';

/**
 * The parts that the four sections for period numbers share (design streaming-sections a to e):
 * the source switch, the month line, the empty state, the plan card and the "not available" block.
 */
export const streamingPeriodMessages = defineMessages({
  switchLabel: { id: 'app.sml.streaming.period.switch.label', defaultMessage: 'Numbers from' },
  switchFrom: { id: 'app.sml.streaming.period.switch.from', defaultMessage: 'from {source}' },
  reasonDoesNotReport: { id: 'app.sml.streaming.period.switch.doesNotReport', defaultMessage: 'Does not report this' },
  reasonNotReadYet: { id: 'app.sml.streaming.period.switch.notReadYet', defaultMessage: 'Not read yet' },
  monthLabel: { id: 'app.sml.streaming.period.month.label', defaultMessage: 'Month' },
  monthsShown: {
    id: 'app.sml.streaming.period.months.shown',
    defaultMessage: 'Shown: {months}, the whole months in this period.',
  },
  monthsNone: {
    id: 'app.sml.streaming.period.months.none',
    defaultMessage: 'This period holds no whole month.',
  },
  reportedBy: {
    id: 'app.sml.streaming.period.reportedBy',
    defaultMessage: 'As reported by {source} for {period}.',
  },
  noWholeMonthTitle: {
    id: 'app.sml.streaming.period.noWholeMonth.title',
    defaultMessage: 'No whole month in {start} – {end}',
  },
  showMonth: { id: 'app.sml.streaming.period.showMonth', defaultMessage: 'Show {month}' },
  pickDays: { id: 'app.sml.streaming.period.pickDays', defaultMessage: 'Pick {days} days' },
  showOtherSource: { id: 'app.sml.streaming.period.showOtherSource', defaultMessage: 'Show another source' },
  connectInCatalog: { id: 'app.sml.streaming.period.connectInCatalog', defaultMessage: 'Connect a source in Catalog' },
  givenByTitle: { id: 'app.sml.streaming.period.givenBy.title', defaultMessage: 'Sources that report this' },
  givenByNone: {
    id: 'app.sml.streaming.period.givenBy.none',
    defaultMessage: 'No source that MUSIC24 can connect today reports this.',
  },
  notAvailable: {
    id: 'app.sml.streaming.period.notAvailable',
    defaultMessage: 'The numbers are not available on this server yet.',
  },
  planTitle: {
    id: 'app.sml.streaming.period.plan.title',
    defaultMessage: 'See who listens and where your plays come from',
  },
});
